import { StandardsSetsHeader } from "@/search/Langston/FilterPanel/filters/Standards/StandardsModal/shared/StandardsSetsHeader";
import { StandardsList } from "@/search/Langston/FilterPanel/filters/Standards/StandardsModal/shared/StandardsList";
import { StandardsLoadingSpinner } from "../../shared/StandardsLoadingSpinner";

interface AllStandardsListProps {
  limit?:
    | {
        count: number;
        temporarySelectedIds: string[];
        setTemporarySelectedIds: (ids: string[]) => void;
      }
    | undefined;
}

export const AllStandardsList = ({ limit }: AllStandardsListProps) => {
  return (
    <>
      <StandardsSetsHeader />
      <StandardsLoadingSpinner>
        <StandardsList limit={limit} />
      </StandardsLoadingSpinner>
    </>
  );
};
